<div>
  <div class="d-flex justify-content-center">
    <label [for]="id" class="form-label">
      <strong>
        {{ label }}
      </strong>
    </label>
  </div>
  <div class="position-relative">
    <input
      [id]="id"
      type="text"
      class="form-control mt-2"
      [class.disabled]="disabled"
      [placeholder]="placeholder"
      [formControl]="searchInput"
      [attr.disabled]="disabled ? '' : null"
      [attr.aria-disabled]="disabled"
      (blur)="onBlur()"
      (focus)="onFocus()"
      autocomplete="off"
    >

    @if (showDropdown && results.length > 0) {
      <ul class="list-group list-group-flush w-100 shadow mt-1 position-absolute start-0 end-0 overflow-auto z-3" style="max-height: 200px;">
        @for (item of results; track $index) {
          <li class="list-group-item list-group-item-action" (click)="selectItem(item)">
            {{ displayFn(item) }}
          </li>
        }
      </ul>
    }
    @if (showDropdown && results.length === 0 && !loading && ((showAllOnEmpty && (!searchInput.value || searchInput.value.length === 0)) || (searchInput.value && searchInput.value.length >= minSearchLength))) {
      <ul class="list-group list-group-flush w-100 shadow mt-1 position-absolute start-0 end-0 z-3">
        <li class="list-group-item text-muted">Nessun risultato trovato</li>
      </ul>
    }
  </div>
</div>
